import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InfoMessages } from 'apps/driver-dashboardfe/src/app/shared/constants/info-messages.constant';

@Component({
    standalone: false,
    selector: 'octo-info-dialog',
    templateUrl: './info-dialog.component.html',
    styleUrls: ['./info-dialog.component.scss'],
})
export class InfoDialogComponent {
    infoMessages: any = InfoMessages;
    message: any;
    constructor(
        private modalRef: MatDialogRef<InfoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        modalRef.disableClose = false;
        if (typeof data == 'object') {
            const template = this.infoMessages[data['message']];
            if (template) {
                this.message = { ...template };
                for (let key in data) {
                    if (key == 'message') {
                        continue;
                    }
                    this.message['message'] = this.message['message'].replace(
                        '#' + key + '#',
                        data[key]
                    );
                }
            } else {
                this.message = {
                    title: data.title || 'Info',
                    message: data.message,
                    class_name: data.class_name,
                    is_close: data.is_close,
                };
            }
        } else {
            this.message = this.infoMessages[data];
        }
    }
}
